import React from 'react';
import StoryProgress from './StoryProgress';
import '../css/FormAnimations.css';
import ContentBox from './new/ContentBox';
import { ArrowDownward } from '@mui/icons-material';

export default function FormWrapper({
  children,
  steps,
  currentIndex,
  onStepClick,
  onBack,
  onNext,
  backDisabled,
  nextDisabled,
  nextLabel = 'Next',
  backLabel = 'Back',
}) {
  return (

    <ContentBox>
      <div className="form-progress">

        <StoryProgress
          steps={steps}
          currentIndex={currentIndex}
          onStepClick={onStepClick}
        />
      </div>

      {children}

    </ContentBox>

  );
}
